/*
 * TYPINGINDICATOR COMPONENT
 *
 * RENDERS A SIMPLE THREE-DOT ANIMATION TO INDICATE THE AI IS TYPING.
 */

import React from 'react';
import styles from './TypingIndicator.module.scss';

const TypingIndicator = () => {
  return (
    <div className={styles.typingIndicator}>
      <div className={styles.dot}></div>
      <div className={styles.dot}></div>
      <div className={styles.dot}></div>
    </div>
  );
};

export default TypingIndicator;
